import { useState } from "react";
import { useNav } from "../hooks/useNav";
import { isCurrentPage, UNDERLINE_CLASS } from "../utils";
import { useCurrentPage } from "../hooks/useCurrentPage";
import { Button, BUTTON_COLORS, BUTTON_TYPE } from "./Button";

export const Nav = () => {
  const nav = useNav();
  const currentPage = useCurrentPage();
  const [isHidden, setIsHidden] = useState(true);
  return nav.length ? (
    <div id="nav" className="max-w-screen">
      <button
        className={`md:hidden w-full ${BUTTON_TYPE.nav} ${BUTTON_COLORS.nav}`}
        onClick={() => setIsHidden((isHidden) => !isHidden)}
      >
        Menu
      </button>
      <div className="flex flex-wrap flex-col md:flex-row ">
        {nav.map((item) =>
          item.isActive ? (
            <a
              key={item.href}
              href={item.href}
              title={
                isCurrentPage(item.href, currentPage)
                  ? "Current page"
                  : undefined
              }
              className={` w-full inline-block flex-1 text-center m-1 ${
                BUTTON_TYPE.nav
              } ${
                isCurrentPage(item.href, currentPage)
                  ? BUTTON_COLORS.secondary + UNDERLINE_CLASS
                  : BUTTON_COLORS.nav
              } ${
                isHidden
                  ? "-translate-y-[200px] duration-300 hidden md:block sm:translate-y-0"
                  : "block translate-y-0"
              }`}
            >
              {item.text}
            </a>
          ) : null
        )}
      </div>
    </div>
  ) : null;
};
